import { GamesPageTags }            from "_common/seo";
import { initialValidations }       from "_common/ssrWrapper";
import GamesPage                    from "_components/pages/games";
import { getPopularStreamingGames } from "_services/api/broadcast";

const component = props => {
	return (
		<>
			<GamesPageTags
				endpoint = { props?.currentPath }
			/>

			<GamesPage gameList = { props?.gameList } />
		</>
	);
};

const getServerSideProps = async context => initialValidations ( context, async ( defaultProps, context ) => {

	try {
		const result = await getPopularStreamingGames.bind ( defaultProps ) ( { pageNo: 1, pageSize: 50, isDesktopGame: 0, sortByPriority: 1 } );

		if ( !defaultProps?.isLoggedIn && result?.length )
			context.res.setHeader (
				"Cache-Control",
				"public, s-maxage=90, stale-while-revalidate=120"
			);

		return {
			props: {
				...defaultProps,
				gameList: result
			}
		};
	} catch ( err ) {

		if ( err?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			return {
				redirect: {
					destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
					permanent   : false
				}
			};

		return {
			props: {
				...defaultProps,
				gameList: []
			}
		};
	}
} );

export { getServerSideProps };

export default component;
